import type { ReactNode } from 'react';
import { ChevronDown, SlidersHorizontal } from 'lucide-react';
import type { JobMobileState } from './use-job-mobile';
import { MobilePageMode, pageModes } from './MobilePageMode';
import { MobileFields } from './MobileFields';
import { MobileSettings } from './MobileSettings';

/**
 * Scan from a phone › Options: page colour, the fields the phone fills, location and rescans, closed
 * until asked for, its summary saying what each is set to so nothing hides behind it.
 */
export function MobileOptions({ state }: { state: JobMobileState }): ReactNode {
  const mobile = state.mobile;
  if (!mobile) return null;
  return (
    <details className="export-stage paige-phone-options">
      <summary className="export-stage-head">
        <SlidersHorizontal size={18} aria-hidden="true" />
        <h3>Options</h3>
        <span className="export-stage-subtitle">{optionsSummary(state)}</span>
        <ChevronDown className="paige-phone-options-chevron" size={18} aria-hidden="true" />
      </summary>
      <div className="paige-phone-options-body">
        <MobilePageMode state={state} />
        <MobileFields state={state} />
        <MobileSettings state={state} />
      </div>
    </details>
  );
}

/** "Greyscale · 2 fields filled · Location off · Rescan on". */
function optionsSummary({ mobile }: JobMobileState): string {
  if (!mobile) return '';
  const mode = pageModes.find((m) => m.value === (mobile.pageMode ?? 'greyscale'))?.label;
  const filled = mobile.fields.length;
  return [
    mode,
    filled === 0 ? 'No fields filled' : `${filled} field${filled === 1 ? '' : 's'} filled`,
    mobile.locationEnabled ? 'Location on' : 'Location off',
    mobile.autoRescan ? 'Rescan on' : 'Rescan off',
  ].join(' · ');
}
